/* tooltip-container.tsx generated by @compiled/babel-plugin v0.35.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./tooltip-container.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from 'react';
import { N0, N800 } from '@atlaskit/theme/colors';
import TooltipPrimitive from './tooltip-primitive';
var baseStyles = null;
var truncateStyles = null;

/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */
var TooltipContainer = /*#__PURE__*/forwardRef(function TooltipContainer(_ref, ref) {
  var style = _ref.style,
    className = _ref.className,
    children = _ref.children,
    truncate = _ref.truncate,
    placement = _ref.placement,
    testId = _ref.testId,
    onMouseOut = _ref.onMouseOut,
    onMouseOver = _ref.onMouseOver,
    id = _ref.id;
  return /*#__PURE__*/React.createElement(TooltipPrimitive, {
    ref: ref
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,

    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: ax(["_1yt4nmcz _2rko1sit _11c8qk37 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _slp31hna", truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c", className]),
    placement: placement,
    testId: testId,
    id: id,
    onMouseOut: onMouseOut,
    onMouseOver: onMouseOver,
    style: _objectSpread(_objectSpread({}, style), {}, {
      "--_a5vo3x": ix("var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)")),
      "--_yr7xfv": ix("var(--ds-background-neutral-bold, ".concat(N800, ")")),
      "--_ywovvi": ix("var(--ds-text-inverse, ".concat(N0, ")"))
    })
  }, children);
});
TooltipContainer.displayName = 'TooltipContainer';
export default TooltipContainer;